import { FC } from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import useClassNames from 'helpers/hooks/useClassNames';
import { AccordionProps } from '.';
import Typography from '../typography';

type AccordionButtonProps = AccordionProps & {
  open: boolean;
  buttonWrapperClassName?: string;
  buttonClassName?: string;
  sectionTileClassName?: string;
  isHeading?: boolean;
};

const AccordionButton: FC<AccordionButtonProps> = ({
  open,
  buttonWrapperClassName,
  buttonClassName,
  openSectionTitle,
  closedSectionTitle,
  collapsedLabel,
  variant,
  iconClassName,
  sectionTileClassName,
  isHeading,
}) => {
  const buttonClassNames = useClassNames(['w-full flex justify-between', buttonClassName]);

  return (
    <Disclosure.Button className={`${buttonWrapperClassName} w-full`}>
      <div className={buttonClassNames}>
        {isHeading ? (
          <h3 className={`self-center transition ${sectionTileClassName}`}>
            {open ? openSectionTitle : closedSectionTitle}
          </h3>
        ) : (
          <Typography className={`self-center transition ${sectionTileClassName}`}>
            {open ? openSectionTitle : closedSectionTitle}
          </Typography>
        )}
        <div className={`flex items-center gap-8 transition-all duration-500 ease-in-out`}>
          {!open && collapsedLabel && <p className="font-medium text-primary-black">{collapsedLabel}</p>}
          {variant === 'arrow' ? (
            <ChevronDownIcon width={17.5} strokeWidth={1} className={`${open ? 'rotate-180' : ''} ${iconClassName}`} />
          ) : !open ? (
            <p className={`text-30 font-normal text-[#127e57] ${iconClassName}`}>+</p>
          ) : (
            // <PlusIcon width={17.5} strokeWidth={2} className={iconClassName} />
            <p className={`text-30 font-normal text-[#127e57] ${iconClassName}`}>-</p>
            // <MinusIcon width={17.5} strokeWidth={2} className={iconClassName} />
          )}
        </div>
      </div>
    </Disclosure.Button>
  );
};

export default AccordionButton;
